import { BaseEntity } from 'yt-ng-framework';

export class JedinicaMere extends BaseEntity {
    constructor(){
        super();
    }
    Naziv: string = null;
    Oznaka: string = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Oznaka = input.Symbol;
        this.Naziv = input.Name;
        return this;
    }

    Serialize(input: JedinicaMere){
        return {
            ID: input.ID,
            Symbol: input.Oznaka,
            Name: input.Naziv
        };
    }
}
